import { render } from "./switchAdmin.vue?vue&type=template&id=6e44442f&scoped=true"
import script from "./switchAdmin.vue?vue&type=script&lang=js"
export * from "./switchAdmin.vue?vue&type=script&lang=js"

import "./switchAdmin.vue?vue&type=style&index=0&id=6e44442f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e44442f"]])

export default __exports__